export default __webpack_public_path__ + "static/media/1306.69830d84.png";